import { createApiEffect } from '@/features/api/common/create-api-effect'
import { ExportAssignmentQueryParams } from '@/features/api/assignment/types/types'

export const exportResultCoursesListFx = createApiEffect<
  ExportAssignmentQueryParams,
  { task_id: string }
>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/results-app/results/courses/list/export/',
    query,
  }),
})
